module.exports = __webpack_public_path__ + "static/media/Banner.68600b35.jpg";